import { useToast } from "@/hooks/use-toast";
import * as ToastModule from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastModule.ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <ToastModule.Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastModule.ToastTitle>{title}</ToastModule.ToastTitle>}
              {description && <ToastModule.ToastDescription>{description}</ToastModule.ToastDescription>}
            </div>
            {action}
            <ToastModule.ToastClose />
          </ToastModule.Toast>
        );
      })}
      <ToastModule.ToastViewport />
    </ToastModule.ToastProvider>
  );
}
